var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrashcan(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.6665 13.3342H76.6652C78.507 13.3342 80 14.8272 80 16.669V23.3335C80 25.1753 78.507 26.6683 76.6652 26.6683H3.33479C1.49304 26.6683 0 25.1753 0 23.3335V16.669C0 14.8272 1.49304 13.3342 3.33479 13.3342H23.3335V3.33479C23.3335 1.49304 24.8266 0 26.6683 0H53.3317C55.1734 0 56.6665 1.49304 56.6665 3.33479V13.3342ZM50.0018 6.66478H30.0031V13.3294H50.0018V6.66478Z",
    fill: "#2B3E5B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0042 33.333H70.0004V76.6653C70.0004 77.5497 69.6491 78.398 69.0237 79.0234C68.3983 79.6488 67.5501 80.0001 66.6656 80.0001H13.3389C12.4545 80.0001 11.6063 79.6488 10.9809 79.0234C10.3555 78.398 10.0042 77.5497 10.0042 76.6653V33.333ZM23.3383 66.6658H30.0029V46.6671H23.3383V66.6658ZM43.3372 66.6658H36.6676V46.6671H43.3322L43.3372 66.6658ZM50.0017 66.6658H56.6713L56.6663 46.6671H50.0017V66.6658Z",
    fill: "#2B3E5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashcan);
export default __webpack_public_path__ + "static/media/trashcan.7c45752de2f697ebc9049d4ef079d13e.svg";
export { ForwardRef as ReactComponent };